import React from 'react';
import './serviceourconcept.css';
import { FaRegClock, FaChartBar, FaTools } from 'react-icons/fa';
import serviceContent from '../../../content/pages/service.json';

const iconMap = {
    clock: FaRegClock,
    chart: FaChartBar,
    tools: FaTools,
};

const ServiceOurConcept = () => {
    const { heading, introText, cards } = serviceContent.concept;

    return (
        <div className="service-concept-section">
            <h2>{heading}</h2>
            <p className="intro-text">{introText}</p>
            <div className="service-cards">
                {cards.map((card, index) => {
                    const IconComponent = iconMap[card.icon] || FaRegClock;
                    return (
                        <div className="service-card" key={index}>
                            <IconComponent className="service-icon" />
                            <h3>{card.name}</h3>
                            <h4>{card.subtitle}</h4>
                            <ul>
                                {card.items.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ServiceOurConcept;
